import RefreshIcon from '@mui/icons-material/Refresh';
import {
    Box,
    Card,
    CardContent,
    IconButton,
    Theme,
    Typography,
    useMediaQuery
} from '@mui/material';
import { useState } from 'react';
import {
    Datagrid,
    DateField,
    List,
    useListContext,
    useRecordContext,
    useTranslate
} from 'react-admin';
import { MultilineTextField } from '../../components';
import ListPagination from '../../components/ListPagination';
import { StandaloneDateRangeInput } from '../../components/StandaloneDateTimeInput';

const ListActions = () => {
    const { refetch, isFetching } = useListContext();
    const translate = useTranslate();

    return (
        <IconButton
            onClick={() => refetch()}
            disabled={isFetching}
            aria-label={translate('Atualizar')}
            size="small"
            sx={{ mr: 1 }}
        >
            <RefreshIcon />
        </IconButton>
    );
};

export const FillinLogsTab = () => {
    const record = useRecordContext();
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    const [startDate, setStartDate] = useState<string | null>(() => {
        if (record?.receivedAt) {
            const date = new Date(record.receivedAt);
            date.setHours(date.getHours() - 1);
            return date.toISOString();
        }
        return null;
    });
    const [endDate, setEndDate] = useState<string | null>(() => {
        if (record?.receivedAt) {
            return new Date(record.receivedAt).toISOString();
        }
        return null;
    });

    if (!record) return null;

    const filter: any = { fillinId: record.id };
    if (startDate) {
        filter.startDate = startDate;
    }
    if (endDate) {
        filter.endDate = endDate;
    }

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                    Logs da AWS
                </Typography>

                <Box sx={{ mb: 2 }}>
                    <StandaloneDateRangeInput
                        fromValue={startDate}
                        toValue={endDate}
                        onFromChange={setStartDate}
                        onToChange={setEndDate}
                        fromLabel="Data Inicial"
                        toLabel="Data Final"
                    />
                </Box>

                <List
                    resource="fillins/logs"
                    filter={filter}
                    pagination={<ListPagination />}
                    actions={<ListActions />}
                    disableSyncWithLocation
                >
                    <Datagrid
                        bulkActionButtons={false}
                        sx={{
                            '& .RaDatagrid-rowCell': {
                                paddingTop: 1,
                                paddingBottom: 1
                            }
                        }}
                    >
                        <DateField
                            source="@timestamp"
                            label="Data"
                            showTime
                            locales="pt-BR"
                            sx={{ minWidth: isSmall ? 100 : 180 }}
                        />
                        <MultilineTextField
                            source="@message"
                            label="Mensagem"
                            sx={{ width: '100%' }}
                        />
                    </Datagrid>
                </List>
            </CardContent>
        </Card>
    );
};